import { useMemo } from 'react';

import type { I18nFn } from '#/i18n/types/I18nFn';
import type { SearchFacet } from '#/modules/search/types/SearchFacet';

import { actionDateFacet } from './searchFacets/actionDateFacet';
import { eventAreasOfFocusFacet } from './searchFacets/eventAreasOfFocusFacet';
import { eventSourceFacet } from './searchFacets/eventSourceFacet';
import { idealistDaysFacet } from './searchFacets/idealistDaysFacet';
import { localeFacet } from './searchFacets/localeFacet';
import { eventLocationTypeFacet } from './searchFacets/locationTypeFacet';
import { recencyFacet } from './searchFacets/recencyFacet';

/**
 * Only use this function if the code consuming the output does not rely on a stable object.
 *
 * If it does, use the hook instead
 */
export function unstableEventsSearchFacets(i18n: I18nFn) {
  return [
    eventLocationTypeFacet(i18n),
    eventAreasOfFocusFacet(i18n),
    eventSourceFacet(i18n),
    actionDateFacet(i18n),
    localeFacet(i18n),
    idealistDaysFacet(i18n),
    recencyFacet(i18n),
  ] as const satisfies SearchFacet[];
}

export function useSearchFacetsEvent(i18n: I18nFn) {
  const eventSearchFacets = useMemo(
    () => unstableEventsSearchFacets(i18n),
    [i18n],
  );

  return { eventSearchFacets };
}
